import getDoctorsFilterHash from './getDoctorsFilterHash'

describe('getDoctorsFilterHash', () => {
  describe('Когда фильтры пустые', () => {
    test('Тогда hash пустой', () => {
      expect(getDoctorsFilterHash({
        speciality: null,
        experience: '',
        gender: '',
        isHomeCall: false,
      })).toBe('')
    })
  })

  describe('Когда выбраны специальность, стаж, пол и вызов на дом', () => {
    test('Тогда hash совпадает с контрактом ClinicDoctorsFilterMain', () => {
      expect(getDoctorsFilterHash({
        speciality: { id: 12, name: 'Терапевт', translit: 'terapevt' },
        experience: '5',
        gender: 'M',
        isHomeCall: true,
      })).toBe('#speciality=12&staj=5&gender=M&na_dom=true')
    })
  })
})
